/* eslint-disable radix */
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";

export interface RangeSliderEventInterface {
    el: QuizAnswerRange;
    active: boolean;
    nextRoute: undefined|string;
}

export interface RangeDataInterface {
    quantity: number;
    frequency: number;
}

@Component
export class QuizAnswerRange extends ThemeComponent {
    @Ref() slider!: HTMLDivElement;
    @Ref() lineOne!: HTMLParagraphElement;
    @Ref() lineTwo!: HTMLParagraphElement;

    @Ref() data!: HTMLDivElement;

    private _onChange = new SimpleEvent<RangeSliderEventInterface>();

    public get onChange() {
        return this._onChange.asEvent();
    }

    public getData() {
        if (!this.data.dataset.rangeData) {
            return {
                frequency: 1,
                quantity: 1
            };
        }

        return JSON.parse(this.data.dataset.rangeData);
    }

    init() {
        if (
            !this.dataset.texts ||
            !this.dataset.ranges ||
            !this.dataset.frequencies ||
            !this.dataset.quantities) {
            return;
        }

        const start = 1;
        const max = Number(this.dataset.max);
        const separator = ('|###|');
        const quantities:number[] = this.dataset.quantities.split(separator).map((el) => Number(el));
        const texts:string[] = this.dataset.texts.split(separator).map((el) => el);
        const ranges:number[] = this.dataset.ranges.split(separator).map((el) => Number(el));
        const frequencies:number[] = this.dataset.frequencies.split(separator).map((el) => Number(el));

        const slider = noUiSlider.create(this.slider, {
            start: start,
            step: 1,
            tooltips: true,
            connect: [true, false],
            range: {
                min: 1,
                max: max
            },
            format: {
                to: function(value) {
                    return parseInt(value as unknown as string);
                },
                from: function(value) {
                    return parseInt(value);
                }
            }
        });


        this.changeRangeState(
            start,
            quantities,
            texts,
            ranges,
            frequencies
        );

        slider.on('change', (value) => {
            const [ unit ] = value;
            this.changeRangeState(
                unit as number,
                quantities,
                texts,
                ranges,
                frequencies
            );
        });
    }

    changeRangeState(
        unit: number,
        quantities:number[],
        texts:string[],
        ranges:number[],
        frequencies:number[]
    ) {
        let i = 0;

        for(const [index, range] of ranges.entries()) {
            if (unit <= range) {
                i = index;
                break;
            }
        }

        const text = texts[i];
        const weeks = frequencies[i];
        const days = 7 * weeks;

        this.lineOne.textContent = text;
        this.lineTwo.textContent = `Every ${days} days`;

        this.setData(quantities[i], frequencies[i]);
        this.dispatch();
    }

    getRoute() {
        const value = this.dataset.routeTarget;

        if (value === undefined) {
            return undefined;
        }

        if (value === '') {
            return undefined;
        }

        return value;
    }

    setData(quantity:number, frequency:number) {
        const data = {
            quantity,
            frequency
        };

        this.data.setAttribute('data-range-data', JSON.stringify(data));
    }

    dispatch() {
        const value = this.getRoute();

        const data: RangeSliderEventInterface = {
            el: this,
            active: true,
            nextRoute: value
        };

        this._onChange.dispatch(data);
    }
}
